"use strict";

var _slicedToArray = require("/tmp/36d051b/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColorScheme = exports.attachListener = exports.getPreference = exports.matchPreference = exports.makeQuery = exports.values = exports.PREFERENCES = void 0;

var _react = require("react");

var PREFERENCES = {
  DARK: 'dark',
  LIGHT: 'light',
  NONE: 'no-preference'
};
exports.PREFERENCES = PREFERENCES;
var values = [PREFERENCES.DARK, PREFERENCES.LIGHT, PREFERENCES.NONE];
exports.values = values;

var makeQuery = function makeQuery(pref) {
  return "(prefers-color-scheme: ".concat(pref, ")");
};

exports.makeQuery = makeQuery;

var matchPreference = function matchPreference(pref) {
  return window.matchMedia(makeQuery(pref));
};

exports.matchPreference = matchPreference;

var getPreference = function getPreference(preferences) {
  return preferences.map(function (value) {
    return {
      preference: value,
      matchMedia: matchPreference(value)
    };
  }).filter(function (pref) {
    return pref.matchMedia.matches;
  })[0];
};

exports.getPreference = getPreference;

var attachListener = function attachListener(pref, setScheme) {
  var unbind;

  var listener = function listener() {
    var newPref = getPreference(values);
    setScheme(newPref.preference);
    pref.matchMedia.removeListener(listener); // recursion
    // NOTE: we need to attach a new listener to ensure it fires on next change

    unbind = attachListener(newPref, setScheme);
  };

  pref.matchMedia.addListener(listener);
  return function () {
    if (unbind) {
      unbind();
    } else {
      pref.matchMedia.removeListener(listener);
    }
  };
}; // NOTE: outside hook to avoid this value recomputing


exports.attachListener = attachListener;
var initialPreference = getPreference(values);

var useColorScheme = function useColorScheme() {
  if (!('matchMedia' in window)) {
    // can not detect
    return {
      scheme: PREFERENCES.NONE
    };
  }

  var _ref = (0, _react.useState)(initialPreference ? initialPreference.preference : PREFERENCES.NONE),
      _ref2 = _slicedToArray(_ref, 2),
      scheme = _ref2[0],
      setScheme = _ref2[1];

  (0, _react.useEffect)(function () {
    if (!initialPreference) return;
    return attachListener(initialPreference, setScheme);
  }, []);
  return {
    scheme: scheme
  };
};

exports.useColorScheme = useColorScheme;